import { AnyAction, Dispatch } from "redux";
import { ItemLightDto } from "../../../core/items/ItemDataTypes";
import { setItems } from "../../OotrReducer";


export function updateOotItem(item: ItemLightDto, dispatch: Dispatch<AnyAction>) {


    dispatch(setItems(item))
}
